import { get, size } from 'lodash';
import AccountStore from '../../store/accountStore';
import { throwError } from '../../utils/env';
import { AccountOrganisationStorageService } from './AccountOrganisationStorageService';

export class AccountOrganisationDataService {

  static instance = null;

  static getInstance(accountStore) {
    if (!AccountOrganisationDataService.instance) {
      AccountOrganisationDataService.instance = new AccountOrganisationDataService(accountStore);
    }

    return AccountOrganisationDataService.instance;
  }

  /**
   * @return {UserOrganisationInfoData | null}
   */
  get accountOrganisationData() {
    return this._storage.accountOrganisationInfo;
  }

  get _shouldSaveAccountOrgInfo() {
    return (
      Boolean(this._accountOrganisationLogo)
      && this._accountBelongsToSingleOrganisation
      && !(
        this._accountStore.isSuperUser()
        || this._accountStore.isActAsMode()
      )
    );
  }

  get _accountBelongsToSingleOrganisation() {
    const accountOrganisationsAmount = size(get(this._account, 'organisationsIds'));
    return accountOrganisationsAmount === 1;
  }

  get _accountOrganisationLogo() {
    return get(this._account, 'organisationLogoUrl');
  }

  get _accountOrganisationName() {
    return get(this._account, 'organisationName');
  }

  get _account() {
    return this._accountStore.getAccount();
  }

  _storage = new AccountOrganisationStorageService();

  _accountStore;

  constructor(accountStore = AccountStore) {
    if (!accountStore) {
      throwError('AccountOrganisationStorageService ctor: accountStore is required');
    }

    this._accountStore = accountStore;
    this._accountStore.addChangeListener(this.processNextUserAccount);
  }

  processNextUserAccount = () => {
    if (!this._shouldSaveAccountOrgInfo) {
      if (this._storage.accountOrganisationInfo) {
        this._storage.accountOrganisationInfo = null;
      }
      return;
    }

    this._storage.accountOrganisationInfo = this.createAccountOrgData();
  }

  /**
   * @return {UserOrganisationInfoData}
   */
  createAccountOrgData = () => {
    /** @type {UserOrganisationInfoData} */
    const data = {};
    data.organisationLogoUrl = this._accountOrganisationLogo;
    data.organisationName = this._accountOrganisationName;
    return data;
  }

}
